import { CONTACTO_EMAIL, REDES_MIPAE, enlaceWhatsApp, whatsappDisponible } from "../lib/contacto";
import { registrarClicContacto } from "../lib/contactoClic";
import WhatsAppIcon from "./icons/WhatsAppIcon";

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67z" />
    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908z" />
  </svg>
);

const ICONO = { instagram: InstagramIcon, facebook: FacebookIcon, linkedin: LinkedInIcon };

// Las redes de MiPAE, el WhatsApp de Sebastián y el correo, en el pie del
// inicio y en ¿Qué es MiPAE? Rediseño del 2026-10-17 (Sebastián eligió "Con la
// marca" entre tres maquetas, docs/pitch/preview-pie-inicio/): "con los
// colores se ve infantil". Los íconos van en el gris de la tinta, sin círculos
// ni el color de cada marca, y se oscurecen al pasar el mouse. TikTok salió, y
// una red sin dirección no se dibuja: antes salían "próximamente", que se leía
// como un botón roto. El círculo se dibuja chico, pero cada enlace mide 44 px
// para el dedo.
//
// WhatsApp volvió el 2026-10-30 (pedido de Sebastián, historia en
// lib/contacto.js), entre las redes y el correo. Quien no ha entrado abre el
// mensaje para conocer MiPAE; con sesión, el de ayuda (`motivo`). El kill-switch
// lo saca y queda todo como antes.
export default function SocialBar({ className = "", motivo = "general", conSesion = false }) {
  const enlaces = [
    ...REDES_MIPAE.filter((r) => r.url).map((r) => ({ id: r.id, label: r.nombre, href: r.url, Icono: ICONO[r.id] })),
    ...(whatsappDisponible() ? [{
      id: "whatsapp",
      label: motivo === "ayuda" ? "WhatsApp de Sebastián, para pedir ayuda" : "WhatsApp de Sebastián",
      href: enlaceWhatsApp(motivo),
      Icono: WhatsAppIcon,
      canal: "whatsapp",
    }] : []),
    { id: "correo", label: `Correo, ${CONTACTO_EMAIL}`, href: `mailto:${CONTACTO_EMAIL}`, Icono: MailIcon, canal: "correo" },
  ].filter((e) => e.Icono);
  return (
    <div className={`flex items-center ${className}`}>
      {enlaces.map(({ id, label, href, Icono, canal }) => (
        <a
          key={id}
          href={href}
          {...(href.startsWith("mailto:") ? {} : { target: "_blank", rel: "noopener noreferrer" })}
          aria-label={label}
          data-red={id}
          onClick={canal ? () => registrarClicContacto(canal, "pie", { conSesion }) : undefined}
          className="inline-flex w-11 h-11 items-center justify-center rounded-tk-md text-ink-muted hover:text-ink transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
        >
          <Icono />
        </a>
      ))}
    </div>
  );
}
